import { useState, useEffect } from 'react'
import { ResetSubmitted, EmailValue, NewPasswordValues, PasswordCreated } from '../Types/types'
import { api } from '../../Controllers/api'

export function useForgotPassword() {
  const [resetSubmitted, setResetSubmitted] = useState<ResetSubmitted>(false)

  const forgotPassword = (values: EmailValue) => {
    api
      .post(`webuser/forgotpassword`, values, { withCredentials: false })
      .then(result => {
        if (result && result.status === 200) {
          setResetSubmitted(true)
        } else {
          alert('Email not found')
        }
      })
      .catch(err => {
        if (err.response && err.response.data === 'User not found') {
          alert('Email not found')
          window.location.reload()
        }
        console.log(err.response)
      })
  }

  return { resetSubmitted, forgotPassword }
}

export function useNewPassword() {
  const [passwordCreated, setPasswordCreated] = useState<PasswordCreated>(false)

  const newPassword = (values: NewPasswordValues) => {
    const { _id, password, token } = values
    const body = { _id, password, token }

    api
      .post(`webuser/newpassword`, body, { withCredentials: false })
      .then(result => {
        if (result && result.status === 200) {
          setPasswordCreated(true)
        } else {
          alert('Error')
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  return { passwordCreated, newPassword }
}

export function useEmailValidation(input: string) {
  const [emailValidator, setEmailValidator] = useState<boolean>(false)

  const validateEmail = () => {
    if (
      input &&
      input.match(
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|net|ca|org|io|us)/
      )
    ) {
      setEmailValidator(!emailValidator)
    } else {
      setEmailValidator(false)
    }
  }
  useEffect(() => {
    validateEmail()
  }, [input])

  return { emailValidator }
}
